import script from "./OIDCLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./OIDCLogin.vue?vue&type=script&setup=true&lang=js"

import "./OIDCLogin.vue?vue&type=style&index=0&id=66cca7c7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66cca7c7"]])

export default __exports__